import { useState } from 'react'
import { router } from '@inertiajs/react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from '@/components/ui/alert-dialog'
import { buttonVariants } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface DeleteWorkerDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  workerId: string
  instanceName: string
}

export default function DeleteWorkerDialog({
  open,
  onOpenChange,
  workerId,
  instanceName,
}: DeleteWorkerDialogProps) {
  const [confirmation, setConfirmation] = useState('')
  const [skipBackup, setSkipBackup] = useState(false)

  const handleClose = () => {
    setConfirmation('')
    setSkipBackup(false)
    onOpenChange(false)
  }

  const handleDelete = () => {
    router.delete(`/dashboard/digital_workers/${workerId}`, {
      data: { skip_backup: skipBackup },
    })
    handleClose()
  }

  const isConfirmed = confirmation === instanceName

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir colaborador digital</AlertDialogTitle>
          <AlertDialogDescription>
            Esta ação não pode ser desfeita. A instância será desprovisionada, e todos os processos vinculados e as integrações atribuídas serão excluídos.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="mt-4 flex items-center gap-2">
          <Checkbox
            id="skip-backup"
            checked={skipBackup}
            onCheckedChange={(checked) => setSkipBackup(checked === true)}
          />
          <Label htmlFor="skip-backup">Remover dados da instância (não manter backup)</Label>
        </div>
        <div className="mt-4">
          <Label htmlFor="confirmation">{`Digite "${instanceName}" para confirmar`}</Label>
          <Input
            id="confirmation"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={instanceName}
            className="mt-1.5"
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleClose}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: 'destructive' })}
            onClick={handleDelete}
            disabled={!isConfirmed}
          >
            Excluir permanentemente
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
